import {Pipe, PipeTransform} from '@angular/core';
import {HolidayCard} from '../interfaces/holiday-card';
import {HolidaySearchFilterService} from '../services/holiday-search-filter.service';

@Pipe({
  name: 'filteredHolidayList'
})
export class FilteredHolidayListPipe implements PipeTransform {

  constructor(private _holidaySearchFilterService: HolidaySearchFilterService) {
  }

  transform(value: HolidayCard[], trigger: any): HolidayCard[] {
    if (value) {
      value.forEach((h, key) => {
        h.index = key;
        h.filteredSolutions = h.solutions.filter(hs => {
          let nightsCondition = true;
          const selectedNights = this._holidaySearchFilterService.filters.nights.filter(e => e.checked).map(e => e.element.id);
          if (selectedNights.length > 0) {
            nightsCondition = selectedNights.includes(hs.nights);
          }
          let basisCondition = true;
          const selectedBasis = this._holidaySearchFilterService.filters.basis.filter(e => e.checked).map(e => e.element.id);
          if (selectedBasis.length > 0) {
            basisCondition = selectedBasis.includes(hs.basis ? hs.basis.id : 'null');
          }
          let priceCondition = true;
          if (this._holidaySearchFilterService.filters.price.selectedMin && this._holidaySearchFilterService.filters.price.selectedMax) {
            const solutionPrice = (hs.hasTotalPrice ? hs.totalPrice : hs.price);
            priceCondition = Math.round(parseFloat(String(solutionPrice))) >= this._holidaySearchFilterService.filters.price.selectedMin && Math.round(parseFloat(String(solutionPrice))) <= this._holidaySearchFilterService.filters.price.selectedMax;
          }
          let departureDateCondition = true;
          const selectedDepartureDates = this._holidaySearchFilterService.filters.departureDate.filter(e => e.checked).map(e => e.element.id);
          if (selectedDepartureDates.length > 0) {
            departureDateCondition = selectedDepartureDates.map(e => this._holidaySearchFilterService.formatDate(e)).includes(this._holidaySearchFilterService.formatDate(hs.dateFrom));
          }
          let accomodationCondition = true;
          const selectedAccomodation = this._holidaySearchFilterService.filters.accomodations.filter(e => e.checked).map(e => e.element.id);
          if (selectedAccomodation.length > 0) {
            accomodationCondition = selectedAccomodation.includes(h.accomodation.id);
          }
          let categoryCondition = true;
          const selectedCategory = this._holidaySearchFilterService.filters.categories.filter(e => e.checked).map(e => e.element.id);
          if (selectedCategory.length > 0) {
            categoryCondition = selectedCategory.includes(h.accomodation ? h.accomodation.category.id : 'null');
          }
          let touroperatorCondition = true;
          const selectedTouroperator = this._holidaySearchFilterService.filters.touroperators.filter(e => e.checked).map(e => e.element.id);
          if (selectedTouroperator.length > 0) {
            touroperatorCondition = selectedTouroperator.includes(h.tourOperator);
          }
          return nightsCondition &&
            basisCondition &&
            priceCondition &&
            departureDateCondition &&
            accomodationCondition &&
            categoryCondition &&
            touroperatorCondition;
        });
        if (h.filteredSolutions.length > 0) {
          h.bestSolution = h.filteredSolutions.reduce((a, b) => {
            if (!a) {
              return b;
            }
            return b.price < a.price ? b : a;
          });
        }
      });
      let filteredHolidays = value.filter(h => (h.filteredSolutions.length > 0));
      const existCustomHoliday = this._holidaySearchFilterService.filters.customHoliday.visible;
      const selectedCustomHoliday = this._holidaySearchFilterService.filters.customHoliday.value;
      if (filteredHolidays.length > 0 && existCustomHoliday && selectedCustomHoliday) {
        filteredHolidays = filteredHolidays.filter(h => (h.isCustom === selectedCustomHoliday));
      }
      this._holidaySearchFilterService.pagination.collectionSize = filteredHolidays.length;
      return filteredHolidays;
    }
  }

}
